// extracted by mini-css-extract-plugin
export var blink = "_styles-module--blink--PZGxG";
export var text = "_styles-module--text--V7Ja9";